"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchedEvent = exports.EventCanceledError = exports.EventDeliveryFailedError = void 0;
var uuid_1 = require("uuid");
var logger_1 = __importDefault(require("../utils/logger"));
var EventDeliveryFailedError = /** @class */ (function (_super) {
    __extends(EventDeliveryFailedError, _super);
    function EventDeliveryFailedError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventDeliveryFailedError;
}(Error));
exports.EventDeliveryFailedError = EventDeliveryFailedError;
var EventCanceledError = /** @class */ (function (_super) {
    __extends(EventCanceledError, _super);
    function EventCanceledError(massage, retry) {
        var _this = _super.call(this, massage) || this;
        _this.retry = retry !== null && retry !== void 0 ? retry : true;
        return _this;
    }
    return EventCanceledError;
}(Error));
exports.EventCanceledError = EventCanceledError;
var DispatchedEvent = /** @class */ (function () {
    function DispatchedEvent(event, id) {
        this.logger = new logger_1.default();
        this.cancel = function (error) {
            if (error) {
                throw error;
            }
            throw new EventCanceledError('Context Cancel');
        };
        this._attempts = 0;
        this._event = event;
        this._id = id !== null && id !== void 0 ? id : (0, uuid_1.v4)();
    }
    DispatchedEvent.system = function () {
        return new DispatchedEvent({ type: 'track', event: 'system' });
    };
    DispatchedEvent.prototype.isSame = function (other) {
        return other._id === this._id;
    };
    DispatchedEvent.prototype.log = function (level, message, extras) {
        this.logger.log(level, message, extras);
    };
    Object.defineProperty(DispatchedEvent.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DispatchedEvent.prototype, "event", {
        get: function () {
            return this._event;
        },
        set: function (evt) {
            this._event = evt;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DispatchedEvent.prototype, "attempts", {
        get: function () {
            return this._attempts;
        },
        set: function (attempts) {
            this._attempts = attempts;
        },
        enumerable: false,
        configurable: true
    });
    DispatchedEvent.prototype.failedDelivery = function () {
        return this._failedDelivery;
    };
    DispatchedEvent.prototype.setFailedDelivery = function (error) {
        this._failedDelivery = error;
    };
    DispatchedEvent.prototype.logs = function () {
        return this.logger.logs;
    };
    DispatchedEvent.prototype.flush = function () {
        this.logger.flush();
    };
    DispatchedEvent.prototype.toJSON = function () {
        return {
            id: this._id,
            event: this._event,
            logs: this.logger.logs,
        };
    };
    return DispatchedEvent;
}());
exports.DispatchedEvent = DispatchedEvent;
//# sourceMappingURL=dispatched-event.js.map